<template>
  <div class="behind-the-number pad">
    <div class="title">
      <p>{{ $t('calculate-value-for-year', { year: $config.year }) }}</p>
      <h3>{{ $t('value-behind-number') }}</h3>
      <p>{{ $t('value-behind-number-hint') }}</p>
    </div>
    <Table :data="activities" :showTotal="true" :showColor="false" />
    <Attachments :title="$t('attachments')" :files="attachments" />
  </div>
</template>

<script>
import Table from '@/components/common/Table';
import Attachments from '@/components/common/Attachments';
import attachments from '@/assets/data/attachments';

export default {
  name: 'behind-the-number',
  components: {
    Attachments,
    Table
  },
  data() {
    return {
      attachments: attachments['behind-the-number']
    };
  },
  computed: {
    activities() {
      return this.$store.getters['activities/list'];
    }
  }
};
</script>

<style lang="scss" scoped>
.behind-the-number {
  width: 100%;
  padding-bottom: $padding/2;
  .title {
    margin-bottom: 2rem;
    @media screen and (max-width: $mq-mobile) {
      margin-bottom: 1rem;
    }
    h3 {
      color: $col-red-light;
    }
  }
  .table {
    margin-bottom: 2rem;
  }
}
</style>
